<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">套餐管理</h4>
            </div>
            <div class="ml-auto">
              <div>
                <base-button
                  style="margin-right: 10px"
                  size="sm"
                  type="danger"
                  @click="handleAddPackage"
                  >添加套餐</base-button
                >
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <base-table :data="tableData" :columns="columns">
            <template slot="columns">
              <th>id</th>
              <th>套餐名称</th>
              <th>套餐下载次数(次)</th>
              <th>套餐时间(天)</th>
              <th>套餐价格(元)</th>
              <th>套餐状态</th>
              <th>套餐排序</th>
              <th class="text-right">操作</th>
            </template>
            <template slot-scope="{ row }">
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>
                <badge type="default"> {{ row.download_num }}次 </badge>
              </td>
              <td>
                <badge type="danger">{{ row.duration }}天</badge>
              </td>
              <td>{{ row.price }}</td>
              <td>
                <base-button
                  v-if="row.state == 0"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="danger"
                  @click="changePackageState(row.id)"
                  ><i class="tim-icons icon-button-pause"></i
                ></base-button>
                <base-button
                  v-if="row.state == 1"
                  style="margin-left: 6px"
                  size="sm"
                  round
                  icon
                  type="success"
                  @click="changePackageState(row.id)"
                  ><i class="tim-icons icon-triangle-right-17"></i
                ></base-button>

                <!-- <badge type="success" v-if="row.state==1">正常</badge>
                <badge type="danger" v-if="row.state==0">停用</badge> -->
              </td>
              <td>{{ row.sort }}</td>
              <td class="text-right">
                <base-button
                  type="success"
                  style="margin-left: 6px"
                  size="sm"
                  icon
                  @click="
                    editPackage(
                      row.id,
                      row.name,
                      row.download_num,
                      row.duration,
                      row.price
                    )
                  "
                >
                  <i style="color: #ffffff" class="tim-icons icon-settings"></i>
                </base-button>
                <base-button
                  type="danger"
                  style="margin-left: 6px"
                  size="sm"
                  icon
                >
                  <i
                    style="color: #ffffff"
                    class="tim-icons icon-simple-remove"
                  ></i>
                </base-button>
              </td>
            </template>
          </base-table>
        </div>
      </template>
      <div>
        <modal :show.sync="modals" headerClasses="justify-content-center">
          <h4 slot="header" class="title title-up">添加套餐</h4>
          <base-input
            label="套餐名称"
            type="text"
            placeholder="请输入套餐名称"
            v-model="packageName"
          ></base-input>
          <base-input
            label="套餐下载次数"
            type="number"
            placeholder="请输入套餐下载次数"
            v-model="siteNum"
          ></base-input>
          <base-input
            label="套餐有效期(天)"
            type="number"
            placeholder="请输入套餐有效期"
            v-model="packageDuration"
          ></base-input>
          <base-input
            label="套餐价格"
            type="number"
            placeholder="请输入套餐价格"
            v-model="packagePrice"
          ></base-input>

          <div style="margin-top: 8px">选择网站</div>
          <el-select
            multiple
            class="select-primary"
            collapse-tags
            v-model="selects1.multiple"
            placeholder="请选择套餐网站"
            style="margin-top: 8px; width: 100%"
          >
            <el-option
              v-for="option in selects1.languages"
              class="select-primary"
              :value="option"
              :label="option.label"
              :key="option.label"
            >
            </el-option>
          </el-select>

          <card
            class="row"
            style="
              height: auto;
              display: flex;
              align-items: center;
              gap: 15px;
              flex-wrap: wrap;
              margin-top: 20px;
              padding-bottom: 10px;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 15px;
                width: 100%;
              "
            >

              <badge
                v-for="pkg in selects1.multiple"
                :key="pkg.value"
                type="default"
              >
                {{ pkg.label }}
              </badge>
            </div>
          </card>
          <div style="margin-top: 18px"></div>
          <template slot="footer">
            <base-button @click="doAddPackage">确定</base-button>
            <base-button type="danger" @click.native="modals = false"
              >取消
            </base-button>
          </template>
        </modal>
      </div>

      <div>
        <modal :show.sync="modals1" headerClasses="justify-content-center">
          <h4 slot="header" class="title title-up">编辑套餐</h4>
          <base-input
            label="套餐名称"
            type="text"
            placeholder="请输入套餐名称"
            v-model="editPackageName"
          ></base-input>
          <base-input
            label="套餐下载次数"
            type="text"
            placeholder="请输入套餐下载次数"
            v-model="editSiteNum"
          ></base-input>
          <base-input
            label="套餐时间(天)"
            type="text"
            placeholder="请输入套餐时间"
            v-model="editPackageDuration"
          ></base-input>
          <base-input
            label="套餐价格"
            type="text"
            placeholder="请输入套餐价格"
            v-model="editPackagePrice"
          ></base-input>

            <div style="margin-top: 10px">套餐对应网站权限</div>

          <card
            class="row"
            style="
              height: auto;
              display: flex;
              align-items: center;
              gap: 15px;
              flex-wrap: wrap;
              margin-top: 10px;
              padding-bottom: 10px;
            "
          >

            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 15px;
                width: 100%;
              "
            >
              <badge
                v-for="pkg in updatePackageList"
                :key="pkg.id"
                type="default"
                >{{ pkg.name }}</badge
              >
            </div>
          </card>

          <div style="margin-top: 18px"></div>
          <template slot="footer">
            <base-button @click="doEditPackage">确定</base-button>
            <base-button type="danger" @click.native="modals1 = false"
              >取消
            </base-button>
          </template>
        </modal>
      </div>
    </card>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import Badge from "@/components/Badge";
import { http } from "../../util/http.js";
import Modal from "@/components/Modal";
import { Select, Option } from "element-ui";
import Swal from "sweetalert2";

export default {
  components: {
    BaseTable,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      packageName: "",
      siteNum: "",
      packageDuration: "",
      packagePrice: "",
      editPackageName: "",
      editPackageDuration: "",
      editPackagePrice: "",
      editSiteNum: "",
      packageId: "",
      columns: ["id", "color", "content", "add_time", "actions"],
      tableData: [],
      packageSIte: [],
      updatePackageList: [],
      modals: false,
      modals1: false,
      selects1: {
        languages: [],
        multiple: "",
      },
      selectedPackages: [],
      packageCounts: {},
    };
  },
  mounted() {
    http
      .get("/v1/admin/getAllPackage", {
        headers: { adminToken: localStorage.getItem("adminToken") },
      })
      .then((res) => {
        if (res.data.code != 200) {
          this.$notify({
            type: "danger",
            message: res.data.message,
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        this.tableData = res.data.data.packageData;
        let siteDataArr = [];
        res.data.data.siteData.forEach((element) => {
          siteDataArr.push({
            value: element.id,
            label: element.name,
          });
        });
        this.selects1.languages = siteDataArr;
      })
      .catch((error) => {
        console.error("发生错误:", error);
        // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
      });
  },
  methods: {
    handleAddPackage() {
      this.modals = true;
    },
    doAddPackage() {
      let packageArr = []; // 套餐网站对应次数
      this.selects1.multiple.forEach((element) => {
        let packageObj = {
          siteId: element.value,
        };
        if (packageObj.num <= 0) {
          this.$notify({
            type: "danger",
            message: "套餐次数不能为空",
            timeout: 2000,
            icon: "tim-icons icon-bell-55",
          });
          return;
        }
        packageArr.push(packageObj);
      });
      if (
        this.packageName == "" ||
        this.packageDuration == "" ||
        this.packagePrice == ""
      ) {
        this.$notify({
          type: "danger",
          message: "参数不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }

      if (packageArr.length <= 0) {
        this.$notify({
          type: "danger",
          message: "套餐对应网站不能为空",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      http
        .post(
          "/v1/admin/addPackage",
          {
            siteNum: this.siteNum,
            packageName: this.packageName,
            packageDuration: this.packageDuration,
            packagePrice: this.packagePrice,
            packageArr: JSON.stringify(packageArr),
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals = false;
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            html: "套餐添加成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    //更新套餐对应网站状态
    updataPackageSiteState(packageSiteId) {
      http
        .post(
          "/v1/admin/updatePackageSitestate",
          {
            packageId: this.packageId,
            packageSiteId: packageSiteId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改更新套餐对应网站状态失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.updatePackageList = res.data.data;
          console.log(res.data.data);

          Swal.fire({
            icon: "success",
            html: "更新套餐对应网站状态成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    changePackageState(id) {
      http
        .post(
          "/v1/admin/changePackageState",
          {
            packageId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改套餐状态失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            html: "更改套餐状态成功",
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    editPackage(id, name, download_num, duration, price) {
      this.modals1 = true;
      this.editPackageName = name;
      this.editSiteNum = download_num;
      this.editPackageDuration = duration;
      this.editPackagePrice = price;
      this.packageId = id;
      http
        .post(
          "/v1/admin/getUpdatePackage",
          {
            packageId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: "获取更新套餐列表失败",
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.updatePackageList = res.data.data;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    doEditPackage() {
      http
        .post(
          "/v1/admin/doUpdatePackage",
          {
            packageName: this.editPackageName,
            packageDuration: this.editPackageDuration,
            packagePrice: this.editPackagePrice,
            packageId: this.packageId,
            siteNum: this.editSiteNum,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.modals1 = false;
          this.tableData = res.data.data.packageData;
          let siteDataArr = [];
          res.data.data.siteData.forEach((element) => {
            siteDataArr.push({
              value: element.id,
              label: element.name,
            });
          });
          this.selects1.languages = siteDataArr;
          Swal.fire({
            icon: "success",
            title: "更新套餐",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
  },
  watch: {
    selectedPackages(newVal, oldVal) {
      oldVal.forEach((pkg) => {
        if (!newVal.includes(pkg)) {
          this.$delete(this.packageCounts, pkg);
        }
      });
      newVal.forEach((pkg) => {
        if (!this.packageCounts[pkg]) {
          this.$set(this.packageCounts, pkg, 1);
        }
      });
    },
  },
};
</script>
<style scoped>
.modal-content {
  width: 800px;
}
</style>



 